import { render, staticRenderFns } from "./TeamLeaderInsertData.vue?vue&type=template&id=254a5024&scoped=true&"
import script from "./TeamLeaderInsertData.vue?vue&type=script&lang=js&"
export * from "./TeamLeaderInsertData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254a5024",
  null
  
)

export default component.exports